/* eslint-disable no-unused-vars */
import Header from "../components/Header/Header";
import Layout from "../components/Layout/Layout";
import Request from "../components/Request/Request";

import Container from '@mui/material/Container'
import { Avatar, Button, Card, CardActionArea, CardActions, CardContent, CardHeader, CardMedia, Grid, IconButton, SvgIcon, Typography, styled } from "@mui/material";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AboutUs from "../components/AboutUs/AboutUs";
import Places from "../components/Places/Places";
import Gallery from "../components/Gallery/Gallery";
import CarRentalIcon from '@mui/icons-material/CarRental';
import { Helmet } from "react-helmet-async";
import { motion } from "motion/react"; 
import { DirectionsCar, DirectionsCarOutlined, LocalShippingOutlined, MoveDownOutlined } from "@mui/icons-material";
import { Link } from "react-router-dom";

const CustomCard = styled(Card)(({ theme }) => ({
  textAlign: "center",
  backgroundColor: "white",
  height: "25rem",
  border: "none",
  boxShadow: "0px 3px 26px 5px #f2f2f2",
  alignItems: "center",
  alignContent: "center"


}));

let Nabidka = [
  {
    id: 1,
    title: "Půjčovna",
    description: "Možnost půjčení dodávky i s řidičem.",
    icon: DirectionsCarOutlined
  },
  {
    id: 2,
    title: "Přeprava",
    description: "Rychlá přeprava osob nebo materiálů",
    icon: LocalShippingOutlined
  },
  {
    id: 3,
    title: "Stěhování",
    description: "Stěhování bytů, domů, firem či sklepů.",
    icon: MoveDownOutlined
  },


]

export const container = {
  hidden: { opacity: 1, scale: 0 },
  visible: {
      opacity: 1,
      scale: 1,
      transition: {
          delayChildren: 0.2,
          staggerChildren: 0.1
      }
  }
};

export const item = {
  hidden: { y: 20, opacity: 0 },
  visible: {
      y: 0,
      opacity: 1
  }
};


export default function Home() {

  return (
    <>
      <Helmet>
        <title>RS Rent Domov | Stěhovací služby a půjčovna vozů</title>
        <meta name="description" content="Nabízíme profesionální stěhovací služby a půjčovnu vozů. Přestěhujeme vás rychle a bezpečně za skvělé ceny. RSrent.cz - váš partner pro stěhování." />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://rsrent.cz/" />
      </Helmet>
      <Layout>
        <Header></Header>
        <Request></Request>
        <Container sx={{

          minHeight: "80vh",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center"
        }} maxWidth="lg">
          <Typography variant="h4">Služby, které nabízíme</Typography>
          <Grid  component={motion.div} viewport={{once : true}} variants={container} initial="hidden" whileInView="visible" container justifyContent={"center"} my={1} spacing={2} >
            {Nabidka.map((element) => (
              <Grid key={element.id} component={motion.div} variants={item} item xs={12} md={4} sx={{
                width: "100%",
                minHeight: "25rem",
              }}>
                <CustomCard>
                  <CardMedia>
                    <SvgIcon sx={{ fontSize: 96, color: "secondary.main" }} component={element.icon} ></SvgIcon>
                  </CardMedia>
                  <CardContent>
                    <Typography variant="body2" sx={{
                      fontWeight: "600"
                    }}>
                      {element.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" mt={2}>
                      {element.description}
                    </Typography>
                  </CardContent>
                  <CardActions disableSpacing sx={{ justifyContent: "center" }}>
                    <Link to={"/sluzby"}>
                    <Button variant="outlined" color="secondary" sx={{}}>
                      Více informací
                    </Button>
                    </Link>
                  </CardActions>
                </CustomCard>
              </Grid>
            ))}
          </Grid>
        </Container>
        <Places></Places>
        <AboutUs></AboutUs>
        <Gallery></Gallery>
      </Layout>
    </>
  );
}
